import * as Factory from 'factory.ts'
import faker from 'faker'

import { CurrencyConstructorFactory } from '@webapp/core/entities/external/Currency/Currency.factory'
import { PrimaryCategoryConstructorFactory } from '@webapp/core/entities/internal/PrimaryCategory'
import { RequesterConstructorFactory } from '@webapp/core/entities/internal/Requester'
import { SecondaryCategoryConstructorFactory } from '@webapp/core/entities/internal/SecondaryCategory'
import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import { Expense, type ExpenseConstructor } from './Expense'
import { ExpenseStatuses } from '../enums/ExpenseStatusEnum'
import { ExpenseApprovalLogConstructorFactory } from '../ExpenseApprovalLog'
import { ExpenseItemConstructorFactory } from '../ExpenseItem'
import { ExpensePermissionsConstructorFactory } from '../ExpensePermissions'
export { ExpenseTravelConstructorFactory } from '../ExpenseTravel'

export const ExpenseConstructorFactory =
  Factory.Sync.makeFactory<ExpenseConstructor>({
    id: Factory.each(() => faker.random.number()),
    uuid: Factory.each(() => faker.random.uuid()),
    title: Factory.each(() => faker.lorem.sentence()),
    status: ExpenseStatuses.PENDING,
    description: Factory.each(() => faker.lorem.paragraph()),
    submittedDate: Factory.each(() => faker.date.past().toISOString()),
    dateLastModified: Factory.each(() => faker.date.recent().toISOString()),
    currency: Factory.each(() => CurrencyConstructorFactory.build()),
    requester: Factory.each(() => RequesterConstructorFactory.build()),
    primaryCategory: Factory.each(() =>
      PrimaryCategoryConstructorFactory.build()
    ),
    secondaryCategory: Factory.each(() =>
      SecondaryCategoryConstructorFactory.build()
    ),
    nextApprover: null,
    nextApproverChoices: [],
    items: Factory.each(() => ExpenseItemConstructorFactory.buildList(2)),
    logs: Factory.each(() => ExpenseApprovalLogConstructorFactory.buildList(1)),
    totalAmount: Factory.each(() => Number.parseFloat(faker.commerce.price())),
    reimbursableAmount: Factory.each(() =>
      Number.parseFloat(faker.commerce.price())
    ),
    permissions: Factory.each(() =>
      ExpensePermissionsConstructorFactory.build()
    ),
    travel: null,
    approvalDelegatee: null,
    commentsCount: Factory.each(() => faker.random.number({ min: 0, max: 20 })),
  })

export const ExpenseFactory = EntityFactory(Expense, ExpenseConstructorFactory)
